<template>
    <div class="slot-holder">
        <slot />
    </div>
</template>

<script>
export default {};
</script>

<style>

</style>
